import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-password-request-confirmation-cmp',
  templateUrl: './password-request-confirmation.component.html',
})
export class PasswordRequestConfirmationComponent {
  resetPasswordConfirmationText =
    'If an account exists with the specified login details you should receive an email with the password reset link in a few minutes. You may need to check your junk folder.';

  constructor(private router: Router) {}

  onReturnToLoginPage() {
    this.router.navigate(['/login']).then((e) => {
      if (e) {
        console.log('Navigation is successful!');
      } else {
        console.log('Navigation has failed!');
      }
    });
  }
}
